import styled from 'styled-components/macro';
import { DarkBlueHeaderL } from '../../../Themes';

export const RewardsHeader = styled(DarkBlueHeaderL)`
  margin-bottom: 1rem;
`;
